/**
 * 主应用 api
 */

const infrastructure = {
  // 获取密钥
  passwordPublicKey: '/infra-authority/password/key',
  // // 登录接口-用户名
  // loginGyl: '/infrastructure-certificate/account/login/pwd',
  // // 登出接口
  // loginOut: '/infrastructure-certificate/account/logout',
  // // 获取验证码 客端
  // sendVerifyCode: 'infrastructure-certificate/account/login/sendVerifyCode',
  // // 获取验证码 商端
  // merchantSendVerifyCode: 'infrastructure-certificate/merchant/login/sendVerifyCode',
  // // 验证码登录-客端
  // crmSms: '/infrastructure-certificate/account/login/sms',
  // // 验证码登录-商端
  // merchantCrmSms: '/infrastructure-certificate/merchant/v2/login/sms',
  // // 自营获取验证码
  // gylSendVerifyCode: '/infrastructure-certificate/login/phone/sendVerifyCode',
  // // 自营验证码
  // gylSms: '/infrastructure-certificate/login/phone/sms',
  // 飞书授权登录
  flyingBookLogin: '/infra-authority/internet/user/login/feishu',
  // 获取mqtt的订阅主题
  getMqtt: '/infra-message/message/account/generateMqttTopic',
  // 获取消息数量  废弃
  getMsgCount: '/infra-message/message/stationLetter/unread/count',
  // 切换用户状态 废弃
  switchState: '/operation-system/operator/state/switch',
  // 运营人员查询自身状态 废弃
  querySelfState: '/operation-system/operator/state/querySelf',
  // 菜单列表 废弃
  // menuList: '/infrastructure-authority/user/authority/resources',
  menuList: '/merchant-authority/v4/merchant/employee/authorityInfo',
  // 按钮权限
  buttonPermissions: '/infra-authority/v1/account/resource/list',
  // 公共菜单
  baseMenuList: '/infra-authority/v1/account/menu/list',
  // 登录后查询用户信息
  loginAccount: '/infra-authority/v1/login/account',
  // 单个消息详情
  queryOne: '/infra-message/message/stationLetter/queryOne',
  // 消息盒子-top5
  listTopFive: '/infra-message/message/stationLetter/listTopFive',
  /// 代办列表
  todoTasks: '/infra-workflow/v1/process/todoTasks',
  // 消息盒子-消息按分类分组统计数量
  listStationLetterCountByType: '/infra-message/message/stationLetter/listStationLetterCountByType',
  // 批量标为已读
  batchMarkRead: '/infra-message/message/stationLetter/batchMarkRead',
  // 租户列表
  tenantList: 'infra-authority/v1/account/tenant',
  // 切换租户
  switchTenant: 'infra-authority/cert/identity/switch',
  // 创建服务单总结
  businessInsert: '/call-center/call/business/insert',
  // 服务总结信息查询
  summaryQuery: '/call-center/call/summary/query',
  // 服务总结-处理进度选项
  summaryConfig: '/call-center/call/summary/config',
  // 服务总结-保存
  summarySave: '/call-center/call/summary/save',
  // 呼叫中心——获取当前登录人的坐席信息
  agentInfo: '/call-center/call/agent/getCurrentAgent',



  // 修改密码
  modifyPassword: '/infra-authority/v1/modify/password',
  // 重置密码
  resetPassword: '/infra-authority/v1/forget/password/phone/modify/pwd',
  // 重置密码发送验证码
  pwdSendVerifyCode: '/infra-authority/internet/user/login/sendVerifyCode',
  // 重置密码验证收集
  verifyPhone: '/infra-authority/forget/password/verify/mobilePhone',
  // 呼叫中心——联系人卡片查询 废弃
  queryContactCard: '/call-center/call/business/queryContactCard',
  // 外呼通话发送消息 废弃
  sendCallOutMessage: '/call-center/message/sendCallOutMessage',
  // 强制修改密码发送验证码
  forcedModifySendCode: '/infra-authority/internet/user/login/sendVerifyCode',
  // 强制修改密码
  forcedModifyPwd: '/infra-authority/password/forcedModify/pwd',
  // 获取字典
  dictionaryTableObject: '/infra-integration/dictionary/object/key/get',
  // 呼叫日志 废弃
  callLogSave: '/call-center/web/call/log/save',
  // 未正常接通回铃音保存 废弃
  recordCallError: '/call-center/call/business/recordCallError',
  // 客saas登录 废弃
  managerLogin: '/infrastructure-certificate/v1/tenant/manager/account/login',
  // 获取环境
  garyEnv: '/infra-authority/login/env',
  // 新飞书审批
  routerParam: '/infra-workflow/v1/process/routerParam',
  // 记录协议和政策
  agreementRecord: '/infra-authority/extend/agreement/record',

  // 雏鹰二期

  // 前端查询应用信息接口
  getAllUiInfo: '/infra-authority/internet/v1/license/app/info',
  // 域账号登录 废弃
  login: '/infrastructure-certificate/internet/user/login/domain',
  // 验证码登录 废弃
  userLoginSms: '/infrastructure-certificate/internet/user/login/sms',
  // 验证码登录 加密
  userLoginSmsV2: '/infra-authority/v2/internet/user/login/sms',
  // 获取验证码
  internetSendVerifyCode: '/infra-authority/internet/user/login/sendVerifyCode',
  // 账号密码登录
  internetLoginPwd: '/infra-authority/internet/user/login/pwd',
  // 获取当前登录账号的激活状态
  queryAccountStatus: '/infra-authority/v1/query/accountStatus',

  // 初始化账号密码
  accountAndPassword: '/infra-authority/v1/modify/accountAndPassword',
  // code换token
  userLoginCode: '/infra-authority/intranet/user/login/code',

   // 获取装修页面
   getUiApply: '/infra-authority/v1/object/700240/layout/1/apply',

   userLoginTps: '/infra-authority/internet/user/login/tps', // 三方系统登录

   accountRoles: '/infra-authority/intranet/v2/tenant/query/login/account/roles',

  // 查询租户管理员
  accountAdminQuery: '/infra-authority/intranet/v2/tenant/account/admin/query',

  // 租户下账号注销接口
  accountCancel: '/infra-authority/intranet/v2/tenant/account/cancel',
  //租户注销接口
  tenantCancel: '/infra-authority/intranet/v2/tenant/cancel',
};

export default {
  ...infrastructure,
};
